import React, { Component } from 'react'
import { singlePost, remove, like, unlike } from './apiPost';
import DefaultImage from '../assets/default-post.jpg';
import { Link, Redirect } from 'react-router-dom';
import LoadingAnim from '../core/LoadingAnim';
import { isAuthenticated } from '../auth';
import Comment from './Comment';

class SinglePost extends Component {
    state = {
        post: '',
        loading: false,
        deleted: false,
        like: false,
        likes: 0,
        redirectToSignin: false,
        comments: []
    }

    checkLike = (likes) => {
        const userId = isAuthenticated() && isAuthenticated().user._id;
        let match = likes.indexOf(userId) !== -1;
        return match;
    }

    componentWillMount = () => {
        const postId = this.props.match.params.postId;
        this.setState({ loading: true });
        singlePost(postId)
            .then(data => {
                if (data.error) {
                    console.log('singelPost:', data.error);
                } else {
                    this.setState({
                        post: data,
                        loading: false,
                        likes: data.likes.length,
                        like: this.checkLike(data.likes),
                        comments: data.comments
                    });
                    //console.log('POST:', data)
                }
            })
    };

    updateComments = comments => {
        this.setState({comments});
    }

    likeToggle = () => {

        if (!isAuthenticated()) {
            this.setState({ redirectToSignin: true });
            return false;
        }

        let callApi = this.state.like ? unlike : like;
        const userId = isAuthenticated().user._id;
        const token = isAuthenticated().token;
        const postId = this.state.post._id;

        callApi(userId, token, postId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    like: !this.state.like,
                    likes: data.likes.length
                })
            }
        })
    }

    deletePost = () => {
        const postId = this.props.match.params.postId;
        const token = isAuthenticated().token;
        remove(postId, token).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ deleted: true })
            }
        })
    }

    deleteConfirmed = () => {
        let answer = window.confirm("Are you sure you want to delete this post?");
        if (answer) {
            this.deletePost();
        }
    }

    renderPost = post => {
        //console.log(post.postedBy)
        //if(!post.postedBy){return}
        //console.log(post)
        const { like, likes } = this.state;
        const posterId = post.postedBy ? `/user/${post.postedBy._id}` : '';
        const posterName = post.postedBy ? post.postedBy.name : 'Unknown';

        return (
            <div className="card mb-2">
                <img
                    className="card-img-top mt-4 img-thumbnail img-fluid"
                    style={{ width: 'auto', maxHeight: '400px', margin: 'auto' }}
                    src={`${process.env.REACT_APP_API_URL}/post/photo/${post._id}`}
                    onError={i => (i.target.src = `${DefaultImage}`)}
                    alt={post.title}
                />

                <div className="card-body">
                    {like ? (
                        <h3 onClick={this.likeToggle}>
                            <i
                                className="fa fa-thumbs-up text-success bg-primary"
                            />Likes: {likes}</h3>
                    ) : (
                            <h3 onClick={this.likeToggle}>
                                <i
                                    className="fa fa-thumbs-down text-warning bg-primary"
                                />Likes: {likes}</h3>
                        )}

                    <p className="card-text">{post.body}</p>
                    <p className="font-italic mark">
                        Posted by: <Link to={`${posterId}`}>{posterName}</Link>
                        <br />Date: {new Date(post.created).toDateString()}
                    </p>
                    <div className="d-inline-block">
                        <Link to={'/'} className="btn btn-raised btn-primary btn-sm mr-3" >Back to Posts</Link>
                        {isAuthenticated().user && isAuthenticated().user._id === post.postedBy._id &&
                            <>
                                <Link to={`/post/edit/${post._id}`} className="btn btn-raised btn-success btn-sm mr-3">Edit Post</Link>
                                <button onClick={this.deleteConfirmed} className="btn btn-raised btn-sm btn-danger">Delete Post</button>
                            </>
                        }
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { post, loading, deleted, redirectToSignin, comments } = this.state;

        if (deleted) {
            return <Redirect to={'/'} />
        } else if (redirectToSignin) {
            return <Redirect to={'/signin'} />
        }

        return (
            <div className="container">
                <h2 className="mt-5">{post.title}</h2>
                {loading ? <LoadingAnim /> : this.renderPost(post)}
                <Comment 
                    postId={post._id} 
                    comments={comments.reverse()} 
                    updateComments={this.updateComments}
                />
            </div>
        )
    }
}

export default SinglePost;